import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import * as minimaleEisenPerDossierActions from "../../actions/minimaleEisenPerDossierActions";
import * as infrastructuurActions from "../../actions/infrastructuurActions";
import * as layoutActions from "../../actions/layoutActions";
import * as documentActions from "../../actions/documentActions";
import AutoBindComponent from "../common/AutoBindComponent";
import MinimaleEisenForm from "./MinimaleEisenPerDossierForm";
import MinimaleEisenPerDossierPageHelper from "./MinimaleEisenPerDossierPageHelper";
import unsavedDataDialogHandler from "../common/UnsavedDataDialogHandler";
import * as types from "../../constants/ComponentConstants";
import convertToLabelValuePair from "../../util/convertToLabelValuePair.js";
import EasterEggHandler from "../common/EasterEggHandler";
import * as pageConstants from "../../constants/EasterEggConstants";

class MinimaleEisenPerDossierPage extends AutoBindComponent {
	constructor(props, context) {
		super(props, context);

		this.state = {
			titleSet: false,
			fileSessionStarted: false,
			hasUnsavedChanges: false,
			documenten: [],
			sjablonen: [],
			minimaleEisenPerDossier: null,
			opbrengstKostInvesteringen: [],
			financiers: []
		};

		this.pageHelper = new MinimaleEisenPerDossierPageHelper(this);
		this.easterEggHandler = new EasterEggHandler(this, pageConstants.MINIMALEEISENALGEMEEN);
	}

	componentWillReceiveProps(nextProps) {
		this.pageHelper.update(nextProps);
	}

	componentWillMount() {
		this.pageHelper.init();
	}

	handleOnChange(event, data) {
		this.pageHelper.onChange(event, data);
	}

	handleOnTopsportfederatieChange(event, i) {
		this.pageHelper.onTopsportfederatieChange(event, i);
	}

	handleOnTopsportfederatieAdd() {
		this.pageHelper.onTopsportfederatieAdd();
	}

	handleOnTopsportfederatieRemove(i) {
		this.pageHelper.onTopsportfederatieRemove(i);
	}

	handleOnDropFiles(component, files) {
		this.pageHelper.onDropFiles(component, files);
	}

	handleOnDeleteFile(component, fileName) {
		this.pageHelper.onDeleteFile(component, fileName);
	}

	handleOnSave(event) {
		this.pageHelper.onSave(event);
	}

	componentDidMount() {
		this.easterEggHandler.bind();
	}

	componentWillUnmount() {
		this.easterEggHandler.unbind();
	}

	isReadyToRender() {
		// entity not loaded? not ready yet...
		if (!this.state.minimaleEisenPerDossier) {
			return false;
		}

		return true;
	}

	render() {
		if (!this.isReadyToRender()) {
			return null;
		}        
		const validationMessageType = this.props.validationMessageType;

		return (
			<MinimaleEisenForm
				minimaleEisenPerDossier={this.state.minimaleEisenPerDossier}
				opbrengstKostInvesteringen={this.state.opbrengstKostInvesteringen}
				documenten={this.state.documenten}
				sjablonen={this.state.sjablonen}
				fileTypes={this.props.fileTypes}
				okiTypes={this.props.okiTypes}
				disabled={this.props.disabled}
				hasUnsavedChanges={this.state.hasUnsavedChanges}
				errors={this.state.errors}
				validationMessageType={this.props.validationMessageType}
				onChange={this.handleOnChange}
				onDropFiles={this.handleOnDropFiles}
				onDeleteFile={this.handleOnDeleteFile}
				onSave={this.handleOnSave}
				deadlinesStartWerken={this.props.deadlinesStartWerken}
				onTopsportfederatieChange={this.handleOnTopsportfederatieChange}
				onTopsportfederatieAdd={this.handleOnTopsportfederatieAdd}
				onTopsportfederatieRemove={this.handleOnTopsportfederatieRemove}
				color={types.COLOR_GREEN_LIGHT}
				fileSessionStarted={this.state.fileSessionStarted}
				validationMessageType={validationMessageType} />
		);
	}
}

// ----------------------------------------------------------------------------
MinimaleEisenPerDossierPage.propTypes = {
	minimaleEisen: PropTypes.object.isRequired,
	fileTypes: PropTypes.object.isRequired,
	saveMinimaleEisenPerDossier: PropTypes.func.isRequired,
	loadMinimaleEisenPerDossier: PropTypes.func.isRequired,
	loadInfrastructurenByDossierId: PropTypes.func.isRequired,
	loadLayout: PropTypes.func.isRequired,
	uploadDocument: PropTypes.func.isRequired,
	deleteDocument: PropTypes.func.isRequired,
	startFileSession: PropTypes.func.isRequired,
	endFileSession: PropTypes.func.isRequired,
	getContent: PropTypes.func.isRequired,
	getSjablonen: PropTypes.func.isRequired,
	disabled: PropTypes.bool,
	errors: PropTypes.object,
	validationMessageType: PropTypes.string
};

function mapStateToProps(state, ownProps) {
	const dossierId = ownProps.params.dossierId;
	const minimaleEisenPerDossier = state.minimaleEisenPerDossier;
	const disabled = state.ajaxCounter > 0 || state.settings.lockAllDossiers || ((minimaleEisenPerDossier.item) && minimaleEisenPerDossier.item.redenVanStatus == 121450000);
	const infrastructuurId = state.infrastructuren[0] !== undefined ? state.infrastructuren[0].id : null;

	return {
		disabled: disabled,
		minimaleEisenPerDossier: minimaleEisenPerDossier.item,
		errors: minimaleEisenPerDossier.errors,
		validationMessageType: minimaleEisenPerDossier.hasValidationErrors ? types.ValidationMessageTypes.ERROR : types.ValidationMessageTypes.WARNING,
		dossierId: dossierId,
		deadlinesStartWerken: convertToLabelValuePair(state.referentie.deadlinesStartWerken),
		fileTypes: state.settings.fileTypes,
		infrastructuurId: infrastructuurId
	};
}

function mapDispatchToProps(dispatch) {
	return {
		saveMinimaleEisenPerDossier: bindActionCreators(minimaleEisenPerDossierActions.saveMinimaleEisenPerDossier, dispatch),
		loadMinimaleEisenPerDossier: bindActionCreators(minimaleEisenPerDossierActions.loadMinimaleEisenPerDossier, dispatch),
		loadInfrastructurenByDossierId: bindActionCreators(infrastructuurActions.loadInfrastructurenByDossierId, dispatch),
		loadLayout: bindActionCreators(layoutActions.loadMinimaleEisenDossierPageLayout, dispatch),
		uploadDocument: bindActionCreators(documentActions.uploadDocument, dispatch),
		deleteDocument: bindActionCreators(documentActions.deleteDocument, dispatch),
		startFileSession: bindActionCreators(documentActions.startFileSession, dispatch),
		endFileSession: bindActionCreators(documentActions.endFileSession, dispatch),
		getContent: bindActionCreators(documentActions.getContent, dispatch),
		getContentWithoutLoading: bindActionCreators(documentActions.getContentWithoutLoading, dispatch),
		getSjablonen: bindActionCreators(documentActions.getSjablonen, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(unsavedDataDialogHandler(MinimaleEisenPerDossierPage));